import { apiGet, apiPost } from "@/features/shared/apiClient";

export interface GoldRate {
  pricePerGram: number;
  currency: "INR";
  source: string; // "goldprice.org" | "fallback"
  ts: string;
}

export interface QuoteParams {
  weight?: number;
  rate?: number;
  wastage?: number;
  making?: number;
  stones?: number;
  [k: string]: unknown;
}

export interface Quote {
  _id: string;
  workspaceId: string;
  modelId: string;
  params: QuoteParams;
  total: number;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export const getGoldRate = () => apiGet<GoldRate>("/rates/gold");

export const saveQuote = (input: { modelId: string; params: QuoteParams; total: number }) =>
  apiPost<Quote>("/quotes", input);

export const getQuote = (modelId: string) => apiGet<Quote | null>(`/quotes/${modelId}`);
